import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AssociarCondutorComponent } from '../associar-condutor/associar-condutor.component';
import { AuthService, RolesEnum } from 'src/app/core';
import { Breadcrumb, ImgDialog } from 'src/app/shared/components';
import { CarouselComponent } from 'src/app/shared/components/carousel/carousel.component';
import { abreviateName, catchErr, formatHumanTime, getBadgeColor } from 'src/app/shared/utils';
import { Aferidores, DIOPrecificacao, Dio, ExecucaoDetalhes, StatusExecucaoDIO, DIOCancelamento, DioDetalhesExecucao, StatusAfericaoDIO, DioEventos } from '../dio.model';
import { DioService } from '../dio.service';
import { AssinaturaDioComponent } from 'src/app/dio/view-dio/assinatura-dio/assinatura-dio.component';
import { CancelarDioComponent } from './cancelar-dio/cancelar-dio.component';
import { UsuarioService } from 'src/app/usuario';
import { UpdateAferidorComponent } from './update-aferidor/update-aferidor.component';
import { AfericaoService } from '../afericao.service';
import { AferidorService } from '../aferidor.service';
import { DioEventosService } from '../dio-eventos.service';
import { ObservacaoService } from '../observacao.service';
import { NovaObservacaoDialogComponent } from './nova-observacao-dialog/nova-observacao-dialog.component';

@Component({
    selector: 'view-dio',
    templateUrl: './view-dio.component.html',
    styleUrls: ['./view-dio.component.css'],
    standalone: false
})
export class ViewDioComponent {

    loading = true;
    idDio: string;
    dio = {} as Dio;
    cancelamentos: DIOCancelamento[];
    apontamentos: any[];
    observacoes: any[];
    displayedColumns: string[] = ['dataInicio', 'dataFim', 'kmOrHoraTrabalhada', 'horasDisponiveis', 'motivo', 'usuarioResponsavelEmail'];
    displayedColumnsObservacoes: string[] = ['dataObservacao', 'textoObservacao', 'responsavelObservacao'];
    aferidor: Aferidores;
    eventos: DioEventos[] = [];
    currentRole: string;
    statusRole: string;
    precificacoes: DIOPrecificacao[];
    imagens: any[] = [];
    assinaturas: any[] = [];
    execucaoGPS: DioDetalhesExecucao;
    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Diários de Operação', back: true },
        { label: 'Visualizar DIO' },
    ]

    getBadgeColor = getBadgeColor;
    formatHumanTime = formatHumanTime;
    abreviateName = abreviateName;
    RolesEnum = RolesEnum;

    constructor(
        public authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private dioService: DioService,
        private afericaoService: AfericaoService,
        private observacaoService: ObservacaoService,
        private aferidorService: AferidorService,
        private dioEventosService: DioEventosService,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private readonly userService: UsuarioService
    ) { }

    ngOnInit() {        
        this.idDio = this.activatedRoute.snapshot.params['idDio'];
        this.currentRole = this.authService.user.realm_access.roles[0];
        this.getDio();        
    }

    print() {
        window.print();
    }

    openAssociarCondutorDialog() {
        const dialogRef = this.dialog.open(AssociarCondutorComponent, { data: { dio: this.dio, beneficiaria: this.dio.contrato.beneficiaria.id } });
        dialogRef.afterClosed().subscribe((reload) => !!reload && this.getDio());
    }

    openUpdateAferidorDialog() {
        const dialogRef = this.dialog.open(UpdateAferidorComponent, { 
          data: this.dio, height: '50vh', width: '50vw'
        });
        dialogRef.afterClosed().subscribe((reload) => !!reload && this.getDio());
    }

    openSignatureDialog(assinatura: any) {
        const data = {
            nome: `Condutor: ${this.dio.condutor?.nome || ''}`,
            imagens: [{ url: assinatura.url }], // TODO pegar assinatura correta
            observacao: assinatura.observacao
        }
        this.dialog.open(ImgDialog, { data });
    }

    openCarousel(execucao: ExecucaoDetalhes[]) {
        const data = execucao.map((e) => ({
            src: e.url,
            alt: e.name,
            description: e.descricao,
        }));
        this.dialog.open(CarouselComponent, { data, height: '100vh', width: '60vw' });
    }

    openImageCarousel(imagens: any[]) {
        const data = imagens.map((img) => ({
            src: img.url,
            alt: img.alt || img.descricao || 'Imagem',
            description: img.descricao || img.alt || 'Imagem do DIO',
        }));
        this.dialog.open(CarouselComponent, { data, height: '100vh', width: '60vw' });
    }

    openToSignDialog() {
        this.dialog.open(AssinaturaDioComponent, {
            data: {
                dioId: this.dio.id,
                dioNumber: this.dio.numero,
                statusExecucao: this.dio.statusExecucao
            }, width: '500px'
        })
    }

    syncDadosDeExecucao() {
        this.loading = true;
        this.dioService.synchronizeDadosDeExecucao(this.idDio).subscribe({
            next: () => this.getDio(),
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    allowedEditDio() {
        const allowedRoles = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.CONTRATADO_ADM.toString(),
            RolesEnum.EMISSOR.toString()
        ];

        return (allowedRoles.includes(this.currentRole)) && this.dio.statusExecucao === StatusExecucaoDIO.AGUARDANDO_EXECUCAO;
    }

    allowedAddSEI(){
        const allowedRoles = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.FUNCIONARIO.toString(),
            RolesEnum.AFERIDOR.toString(),
            RolesEnum.COORDENADOR.toString(),
            RolesEnum.FISCAL.toString(),
            RolesEnum.EMISSOR.toString()
        ];

        const allowedStatus = [
            StatusExecucaoDIO.EM_EXECUCAO.toString(),
            StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO.toString(),
            StatusExecucaoDIO.AGUARDANDO_AFERICAO.toString(),
            StatusExecucaoDIO.AGUARDANDO_FISCAL.toString()
        ];

        return (allowedRoles.includes(this.currentRole)) && allowedStatus.includes(this.dio.statusExecucao!);
    }

    allowedAferirDio() {
        const allowedRoles = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.COORDENADOR,                 
            RolesEnum.AFERIDOR,            
            RolesEnum.FISCAL
        ];

        return (allowedRoles.includes(this.currentRole));
    }

    allowedViewMapaDio() {
        const allowedRoles = [
            RolesEnum.GESTAO_ADMIN.toString(),                        
            RolesEnum.COORDENADOR,
            RolesEnum.EMISSOR,
            RolesEnum.FUNCIONARIO,
            RolesEnum.FISCAL,
            RolesEnum.AFERIDOR
        ];

        return (allowedRoles.includes(this.currentRole)) && (this.dio.statusExecucao == 'AGUARDANDO_FUNCIONARIO' || this.dio.statusExecucao == 'AGUARDANDO_FISCAL');
    }

    allowedToCancelDio() {
        return this.dio.statusExecucao !== StatusExecucaoDIO.EXECUTADA &&
            this.dio.statusExecucao !== StatusExecucaoDIO.EXPIRADA &&
            this.dio.statusExecucao !== StatusExecucaoDIO.CANCELADA;
    }

    allowedSignatureDio() {
        const statusRole = this.dio.statusExecucao?.substring(this.dio.statusExecucao?.indexOf('_') + 1)!;        

        return (
            (this.currentRole === RolesEnum.GESTAO_ADMIN || this.currentRole === RolesEnum.FUNCIONARIO || this.currentRole === RolesEnum.FISCAL) &&
            (statusRole == RolesEnum.FUNCIONARIO || statusRole == RolesEnum.FISCAL)
        ) || (this.dio.statusExecucao === StatusExecucaoDIO.CANCELADA && this.currentRole == RolesEnum.FISCAL);
    }

    showCancelarDialog() {
        this.dialog.open(CancelarDioComponent, { data: { dio: this.dio } });
    }

    private getDio() {
        this.loading = true;
        this.dioService.getById<Dio>(this.idDio).subscribe({
            next: (res) => {

                this.dio = res;
                 
                if (!this.dio.hodometroFinal || (this.dio.execucaoDetalhes && this.hasDadosExecucaoAutomaticaVazio(this.dio.execucaoDetalhes))) {                    
                    this.processExecucaoDetalhes(this.dio.execucaoDetalhes || []);
                }
                
                if (res?.afericao?.aferidor?.userId) {                  
                  this.userService.getById<any>(res.afericao.aferidor.userId).subscribe((user) => {
                        this.dio = {
                            ...this.dio,
                            afericao: {
                                ...res.afericao,
                                aferidor: {
                                  ...user,
                                  ...res.afericao
                                }
                            }
                        };
                    });
                }
            
                this.dio.assinaturas = this.dio.assinaturas.sort((a, b) => a.created_at.localeCompare(b.created_at));                

                if (this.dio.id) {
                    this.fetchApontamentos(this.dio.id);
                    this.fetchObservacoes(this.dio.id);
                    this.fetchEventos(this.dio.id);
                    this.fetchPrecificacoes();
                    this.fetchImagens(this.dio.id);
                    this.populateExecucaoGPS(this.dio.execucaoDetalhes || []);
                    this.calculaHoraDisponivel(this.dio);

                    if (this.dio.statusExecucao === StatusExecucaoDIO.CANCELADA) {
                        this.fetchCancelamentos(this.dio.id || '');
                    }
                }

                if (this.dio.afericao && this.dio.afericao.aferidorId) {
                    this.fetchAferidor(this.dio.afericao.aferidorId);
                }
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    private processExecucaoDetalhes(execucaoDetalhes: DioDetalhesExecucao[]): void {
        for (const execucao of execucaoDetalhes) {
            if (execucao.tipo === 'SISTEMA' && execucao.kmRodados && execucao.kmRodados > 0) {
                this.dio.execucaoDetalhesValida = execucao;
            }
    
            if (execucao.tipo === 'SISTEMA' && execucao.kmRodados === 0) {
                this.dioService.findDetalhesExecucao(this.dio.id || '').subscribe((res) => {
                    console.log('Execucao detalhes recuperada devido km 0: ', res);
                    this.dio.execucaoDetalhesValida = res;                    
                });
                return;
            }
    
            if (execucao.kmRodados && execucao.kmRodados < 0) {
                execucao.kmRodados = 0;
                this.dio.execucaoDetalhesValida = execucao;
            }
        }
    }

    private fetchEventos(dioId: string): void {
        this.dioEventosService.findEventosByDIOId(dioId).subscribe({
            next: (res) => {
                this.eventos = res.sort((a, b) => 
                    new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                );
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private fetchApontamentos(dioId: string): void {
        if(this.podeVerApontamentos()) {
            this.afericaoService.getApontamentos(dioId).subscribe({
                next: (res) => {
                    this.apontamentos = res;
                },
                error: (err) => catchErr(err, this.snackBar)
            });
    
        }
    }

    private fetchObservacoes(dioId: string): void {
        if(this.podeVerObservacoes()) {
            this.observacaoService.getObservacoesByDio(dioId).subscribe({
                next: (res) => {
                    this.observacoes = res;
                    console.log('Observações carregadas: ', this.observacoes);
                },
                error: (err) => catchErr(err, this.snackBar)
            });
        }
    }

    private fetchAferidor(aferidorId: string): void {
        this.aferidorService.findAferidorById(aferidorId).subscribe({
            next: (res) => {
                this.aferidor = res;
                console.log('Aferidor carregado: ', this.aferidor);
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private hasDadosExecucaoAutomaticaVazio(execucaoDetalhes: DioDetalhesExecucao[]): boolean {
        return execucaoDetalhes.some((detalhe) => detalhe.tipo === 'SISTEMA' && detalhe.kmRodados === 0);
    }

    canReadPrecificacoes() {
        const rolesNotAllowed = ![
          RolesEnum.AFERIDOR.toString(),           
          RolesEnum.COORDENADOR.toString(),
          RolesEnum.EMISSOR.toString(),
          RolesEnum.FUNCIONARIO.toString(),
          RolesEnum.FISCAL.toString()          
        ].includes(this.currentRole);
        
        const precificacaoExists = this.precificacoes && this.precificacoes.length

        return !!precificacaoExists && rolesNotAllowed;
    }

    canReadTarifacoes() {
        const rolesAllowed = [
          RolesEnum.GESTAO_ADMIN.toString(), 
          RolesEnum.CONTRATADO_ADM.toString(),
          RolesEnum.CONTRATADO_CONDUTOR.toString(),
        ].includes(this.currentRole);
    
        const alocacaoExists = this.dio.alocacao;

        return alocacaoExists && rolesAllowed;
    }

    canChangeAferidor() {
      const rolesAllowed = [
        RolesEnum.COORDENADOR.toString(),
        RolesEnum.GESTAO_ADMIN.toString(),
      ].includes(this.currentRole);
      const statusesAllowed = this.dio.statusExecucao == 'EXECUTADA' && this.dio.statusAfericao == 'AGUARDANDO_AFERICAO' ;

      return statusesAllowed && rolesAllowed;
    }

    iniciarAfericao() {
        this.afericaoService.startAfericao(this.idDio).subscribe({
            next: (res) => {
                this.router.navigate(['/dio', this.idDio, 'aferir']);
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private fetchPrecificacoes() {                
        if(this.podeVisualizarPrecificacoes()) {
            this.loading = true;
            this.dioService.findPrecificacoesByDIOId(this.idDio).subscribe({
                next: (res) => { 
                    this.precificacoes = res;
                    console.log('precificacoes: ', this.precificacoes);
                },
                error: (err) => catchErr(err, this.snackBar)
            }).add(() => this.loading = false);
        }         
    }

    private fetchImagens(dioId: string): void {
        this.dioService.findImagensByDioId(dioId).subscribe({
            next: (res) => {
                this.imagens = res;                
                console.log('Imagens carregadas: ', this.imagens);
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private populateExecucaoGPS(execucaoDetalhes: DioDetalhesExecucao[]): void {
        this.execucaoGPS = execucaoDetalhes.find(exec => exec.tipo === 'SISTEMA') || {} as DioDetalhesExecucao;

        console.log('Execução GPS populada: ', this.execucaoGPS);
    }

    private calculaHoraDisponivel(dio: Dio): void {
        if(dio.dataInicioExecucao && dio.dataFimExecucao){
            const totalMinutes = Math.round((new Date(dio.dataFimExecucao).getTime() - new Date(dio.dataInicioExecucao).getTime()) / 60000);
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            this.dio.totalHoraDisponivel = `${hours}h ${minutes}min`;
        }
    }

    private fetchCancelamentos(dioId: string): void {
        this.dioService.findCancelamentos(dioId).subscribe({
            next: (res) => {
                this.cancelamentos = res;                
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private podeVisualizarPrecificacoes() {        
        const rolesAllowed = [RolesEnum.AFERIDOR.toString(), RolesEnum.GESTAO_ADMIN.toString()];        
        
        const isRoleAllowed = this.currentRole 
            ? rolesAllowed.includes(this.currentRole)
            : false;

        return isRoleAllowed;
    }

    podeExibirUsoEquipamento(): boolean {
        const statusExibirUsoEquipamento = [
            StatusExecucaoDIO.EXECUTADA, 
            StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO, 
            StatusExecucaoDIO.AGUARDANDO_FISCAL,
            StatusExecucaoDIO.AGUARDANDO_AFERICAO,            
        ];        

        return !!this.dio.execucaoDetalhesValida && statusExibirUsoEquipamento.includes(this.dio.statusExecucao!);
    }

    podeVerAfericao() {
        const rolesNotAllowed = [RolesEnum.COORDENADOR.toString()];

        if(rolesNotAllowed.includes(this.currentRole)) {
            return false;
        }

        const statusVerAfericaoFuncionario = [
            StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO,
        ]

        if(this.currentRole == RolesEnum.FUNCIONARIO && 
            statusVerAfericaoFuncionario.includes(this.dio.statusExecucao!)) {
            return true;
        }

        return false;
    }

    podeVerApontamentos() {
        return this.currentRole !== RolesEnum.EMISSOR;
    }

    podeVerObservacoes() {
        return true;
    }

    isMaquina() {
        return this.dio.alocacao.equipamento.grupo.tarifacoes === 'MAQUINAS';
    }

    isVeiculo() {
        return this.dio.alocacao.equipamento.grupo.tarifacoes === 'VEICULOS';
    }

    openNovaObservacaoDialog(): void {
        const dialogRef = this.dialog.open(NovaObservacaoDialogComponent, {
            data: { dioId: this.idDio },
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loading = true;
                this.observacaoService.createObservacao(result).subscribe({
                    next: () => {
                        this.snackBar.open('Observação criada com sucesso!', 'Fechar', { duration: 3000 });
                        this.fetchObservacoes(this.idDio); // Recarrega as observações
                    },
                    error: (err) => {
                        catchErr(err, this.snackBar);
                    }
                }).add(() => this.loading = false);
            }
        });
    }
}